import { OnInit, Component, Output, EventEmitter, Input } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/shared/services/util.service';
import { AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';

@Component({
    selector: 'app-informacion-contacto-component',
    templateUrl: './informacion-contacto.component.html',
    styleUrls: ['./../administrar-funcionarios.component.scss']
})
export class InformacionContactoComponent implements OnInit {
    @Input() datosFuncionario: AdministrarFuncionarioDTO;
    @Input() deshabilitado: boolean;
    public correoInvalido = false;
    public rolUsuario: string;

    constructor(
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
    }

    /**
     * Método que valida si el correo ingresado es valido
     * @author jnmartinez
     */
    validarCorreo() {
        this.correoInvalido = this.utilService.validarCamposObligatorios(this.datosFuncionario.correoPersonal) ? 
            this.utilService.validarCorreo(this.datosFuncionario.correoPersonal)
            : false;
    }
}
